import PocketBase from 'pocketbase'

export default defineNuxtPlugin({
  name: 'pocketbase',
  async setup(_nuxtApp) {
    if (import.meta.server) {
      const { EventSource } = await import('eventsource')
      globalThis.EventSource = EventSource
    }

    const { backendUrl } = useRuntimeConfig().public
    const pb = new PocketBase(backendUrl)
    pb.autoCancellation(false)
    const cookie = useCookie('pb_auth', {
      path: '/',
      secure: true,
      sameSite: 'strict',
      httpOnly: false, // change to "true" if you want only server-side access
      maxAge: 604800,
    })

    // load the store data from the cookie value
    const savedAuth = cookie.value
    if (savedAuth?.token && savedAuth?.model) {
      pb.authStore.save(savedAuth.token, savedAuth.model)
    }
    // send back the default 'pb_auth' cookie to the client with the latest store state
    pb.authStore.onChange(() => {
      cookie.value = {
        token: pb.authStore.token,
        model: pb.authStore.model,
      }
    })

    if (pb.authStore.token) {
      await pb.collection('_superusers').authRefresh().catch(() => { })
      await pb.collection('admins').authRefresh().catch(() => { })
      await pb.collection('users').authRefresh().catch(() => { })
    }

    if (!pb.authStore.isValid) {
      pb.authStore.clear()
    }

    return {
      provide: { pb },
    }
  },
})
